import React, { Fragment, useState, useRef } from "react";

import Image from "./Image";
import FilmStrip from "./FilmStrip";
import Lightbox from "./Lightbox";

const ImagesHorizontal = ({ images }) => {
    const lightboxRef = useRef();

    const [currentModal, setCurrentModal] = useState(null);

    return (
        <Fragment>
            {images.length ? (
                <Fragment>
                    <FilmStrip>
                        {images.map((image, index) => (
                            <Image
                                onClick={() => {
                                    setCurrentModal(index);
                                    lightboxRef.current.changeIndex(index);
                                }}
                                key={index}
                            >
                                <img
                                    alt={"caption"}
                                    src={image.source}
                                    style={{
                                        cursor: "pointer",
                                        position: "absolute",
                                        // width: "100%"
                                    }}
                                />
                            </Image>
                        ))}
                    </FilmStrip>
                    <Lightbox
                        images={images}
                        currentModal={currentModal}
                        ref={lightboxRef}
                    ></Lightbox>
                </Fragment>
            ) : (
                <Fragment></Fragment>
            )}
        </Fragment>
    );
};

export default ImagesHorizontal;
